import * as constants from "redux/constants/index";
import * as apis from "redux/requests/apis";
import API_REQUEST from "redux/requests";

export const getWidget = (public_key) => async (dispatch) => {
  try {
    dispatch({ type: constants.GET_CHAT_WIDGET_REQUEST });
    const res = await API_REQUEST(
      constants.GET,
      `${apis.GET_WIDGET_API}/${public_key}`
    );

    dispatch({ type: constants.GET_CHAT_WIDGET_SUCCESS, payload: res?.data });
  } catch (err) {
    console.log("getWidget", err);
    dispatch({ type: constants.GET_CHAT_WIDGET_FAIL });
  }
};

